export default {
  productVatIncluded: {
    id: 'product_vat_included',
    defaultMessage: 'VAT inclusive*',
  },
}
